export default {
  namespaced: true,
  state: {
    customerNotes: [],
    count: 0,
  },
  getters: {
    customerNotes: (state) => state.customerNotes,
    count: (state) => state.count,
  },
  mutations: {
    customerNotes: (state, payload) => (state.customerNotes = payload),
    count: (state, payload) => (state.count = payload),
  },
  actions: {
    list({ commit }, queryParams) {
      return this.$apiService
        .get("/customer-notes", {
          params: queryParams,
        })
        .then((res) => {
          commit("customerNotes", res?.data?.data ?? []);
          commit("count", res?.data?.total ?? 0);
          return res;
        });
    },
    create({}, payload) {
      return this.$apiService.post("/customer-notes", payload);
    },
    show({}, id) {
      return this.$apiService.get(`/customer-notes/${id}`);
    },
    update({}, { id, data }) {
      return this.$apiService.put(`/customer-notes/${id}`, data);
    },
    destroy({}, id) {
      return this.$apiService.delete(`/customer-notes/${id}`);
    },
  },
};
